import { Box, Button, useTheme } from "@mui/material";
import { FC } from "react";
import { useIsMobile } from "../../hooks/useIsMobile";

export const DeleteActionCell: FC<{
  onClick: (e: React.MouseEvent) => void;
  actionText?: string;
}> = ({ onClick, actionText }) => {
  const theme = useTheme();

  const isMobile = useIsMobile();
  const width = isMobile ? "100%" : undefined;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: { xs: "center", md: "flex-end" },
        width: "100%",
      }}
    >
      <Button
        onClick={onClick}
        sx={{
          opacity: { xs: 1, md: 0 },
          color: theme.colors.primary[5],
          fontWeight: 600,
          width,
          fontSize: 14,
          height: { xs: undefined, md: 20 },
          backgroundColor: isMobile ? undefined : "transparent",
          "tr:hover &": {
            opacity: 1,
            backgroundColor: "transparent",
          },
        }}
        variant="secondary"
      >
        {actionText}
      </Button>
    </Box>
  );
};
